<template>
  <Modal :model-value="modelValue" @input="$emit('update:modelValue', false)">
    <div class="popup-content flex flex-wrap">
      <div class="w-full bg-blue px-8 py-16 text-white md:w-1/2">
        <h1 class="mb-10 text-4xl font-bold leading-tight">
          Reserve your room while it’s still available.
        </h1>

        <ul class="tick-list">
          <li class="mb-4">
            Best rate guaranteed
          </li>
          <li class="mb-4">
            Free cancellation available
          </li>
        </ul>
      </div>
      <div class="w-full px-8 py-10 md:w-1/2">
        <div v-for="venue in [venue1, venue2]" :key="venue.id">
          <div v-if="venue.booking_url" class="my-4 rounded-md bg-white p-4 text-center shadow-dropdown">
            <div class="text-xl font-medium text-gray-dark">
              {{ venue.name }}
            </div>
            <div class="text-xl font-bold text-slate">
              {{ $f.currency(venue.low_rate, currency) }}
            </div>
            <a
              :href="bookingUrl(venue)"
              target="_blank"
              rel="noopener noreferrer"
              class="blue-btn"
            >View Deal</a>
            <img class="mx-auto mt-2" src="~/assets/images/bookingcom.svg">
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'pinia'
import Modal from '~/components/shared/Modal'
import bookingUrl from '~/mixins/booking-url'
import { useCurrenciesStore } from '~/stores/currencies'

export default {
  components: { Modal },

  mixins: [bookingUrl],

  props: {
    modelValue: { type: Boolean, required: true },
    venue1: { type: Object, required: true },
    venue2: { type: Object, required: true },
  },

  emits: ['update:modelValue'],

  computed: {
    ...mapState(useCurrenciesStore, ['currency']),
  },
}
</script>

<style lang="scss" scoped>
ul.tick-list > li {
  position: relative;
  padding-left: 35px;

  &:before{
    content: "";
    width: 24px;
    height: 24px;
    position: absolute;
    top: -1px;
    left: 0;
    background: url('~/assets/images/yellow-check.svg');
  }
}
.blue-btn {
  @apply block text-center bg-blue h-10 leading-8 rounded-md text-white text-sm uppercase px-2 py-1 mt-2 mx-auto;
  max-width: 146px;

  &:hover {
    @apply bg-blue-dark;
  }
}
</style>
